import styled from 'styled-components';

export const Container = styled.div`
    padding: 20px;
`;

export const Title = styled.h1`
    font-size: 2.5rem;
    color: #333;
`;

export const Subtitle = styled.h2`
    font-size: 1.8rem;
    color: #666;
`;

export const Form = styled.div`
    margin-bottom: 20px;
`;

export const Label = styled.label`
    display: block;
    margin: 10px 0 5px;
`;

export const Input = styled.input`
    width: 250px;
    padding: 8px;
    margin-bottom: 15px;
    border: 1px solid #ccc;
    border-radius: 4px;
`;

export const DescriptionInput = styled.textarea`
    width: 240px;
    padding: 8px;
    margin-bottom: 15px;
    border: 1px solid #ccc;
    border-radius: 4px;
    height: 80px;
`;

export const DescriptionRow = styled.div`
    display: flex;
    justify-content: flex-start;
    gap: 10px;
`;

export const DescriptionRow2 = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Button = styled.button`
    padding: 10px;
    background-color: #4caf50;
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 4px;
    font-size: 1rem;
    margin-left: auto;
    display: block;

    &:hover {
        background-color: #45a049;
    }
`;

export const DisabledButton = styled.button`
    padding: 10px;
    background-color: #cccccc;
    color: #666666;
    border: none;
    border-radius: 4px;
    font-size: 1rem;
    margin-left: auto;
    display: block;
    cursor: not-allowed;
`;

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;

    th,
    td {
        padding: 10px;
        text-align: left;
        border: 1px solid black;
    }

    th {
        background-color: #f4f4f4;
    }
`;

export const AddMoreButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    padding: 8px 12px;
    background-color: #2196f3;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    margin: 10px 0;
    font-size: 0.9rem;
    width: 250px;

    &:hover {
        background-color: #0b7dda;
    }
`;

export const RemoveFieldButton = styled.button`
    position: absolute;
    right: 0;
    top: 0;
    background: #ff4444;
    color: white;
    border: none;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0;

    &:hover {
        background: #cc0000;
    }
`;

export const IconButton = styled.button`
    background: none;
    border: none;
    color: #4caf50;
    cursor: pointer;
    padding: 5px;
    font-size: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;

    &:hover {
        color: #45a049;
    }
`;

export const Select = styled.select`
    width: 260px;
    padding: 8px;
    margin-bottom: 15px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: white;
`;

export const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

export const ModalContent = styled.div`
    background: white;
    padding: 20px;
    border-radius: 5px;
    width: 80%;
    max-width: 800px;
    max-height: 90vh;
    overflow-y: auto;
`;
